import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum IntegrationSecurityRight {
    CanAccess = 5800,
    ManageIntegrations = 5801
}

export class IntegrationSecurityModule extends BaseSecurityModule<IntegrationSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Integrations,
            [
                { _id: IntegrationSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: IntegrationSecurityRight.ManageIntegrations, name: 'Manage Integrations', basic: false },
            ] as SecurityRight<IntegrationSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }

}
